<!--
 * @Description:
 * @Date: 2020-07-21 09:52:02
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="ruleForm question">
    <!-- 左侧 -->
    <el-scrollbar
      style="height:100%;width:30%;min-width:350px;"
      :wrapStyle="[{ 'overflow-x': 'hidden' }]"
    >
      <div class="question-left">
        <div class="l-c-title">题型模板</div>
        <ul class="upload-template">
          <div class="text">
            <span>上传文件内容：</span>
            <importTemplate
              :projectId="formInline.projectId"
              @questionListUpdate="questionListUpdate"
            ></importTemplate>
          </div>
          <div class="tips">
            通过本功能上传问卷，问卷内容将在右侧编辑场景下方展示。
          </div>
        </ul>
      </div>
      <div class="question-left">
        <div class="l-c-title">题目类别</div>
        <ul v-for="item in typeList" :key="item.title">
          <li>
            <p class="question-left-title l-common-title">{{ item.title }}</p>
            <ul class="question-left-item2">
              <li
                class="hand"
                v-for="item2 in item.list"
                :key="item2.title"
                @click="pushQuestion(item2)"
              >
                <img :src="item2.icon" alt />
                <span>
                  {{ item2.type == -1 ? item2.title.slice(2) : item2.title }}
                </span>
              </li>
              <li class="blank"></li>
              <li class="blank"></li>
            </ul>
          </li>
        </ul>
      </div>
    </el-scrollbar>

    <!-- 右侧 -->
    <div class="question-right">
      <el-scrollbar
        style="height:100%;width:100%;"
        :wrapStyle="[{ 'overflow-x': 'hidden' }]"
      >
        <div class="question-right-block">
          <div class="l-c-title">编辑场景</div>
          <div class="question-right-c">
            <div>
              <el-input
                type="textarea"
                autosize
                v-model.trim="common.sceneTitle"
                placeholder="请输入场景名称"
                :maxlength="50"
                show-word-limit
                style="margin-bottom:10px;"
              ></el-input>
              <el-input
                type="textarea"
                autosize
                v-model.trim="common.sceneRemark"
                placeholder="请输入说明"
                style="margin-bottom:10px;"
                :maxlength="200"
                show-word-limit
              ></el-input>
              <el-card
                shadow="hover"
                class="item"
                v-for="(item, index) in dealQuestionList"
                :key="index"
              >
                <div class="item-title">
                  <div class="item-mr">
                    <span style="color:red">
                      [{{ item | questionTypeLabelFil }}]
                    </span>
                  </div>
                </div>
                <!-- 标题 -->
                <p class="item-title__p">
                  <el-input
                    disabled
                    placeholder="顺序"
                    style="width:45px;margin-right:5px"
                    size="small"
                    :value="index + 1"
                  ></el-input>
                  <el-input
                    type="text"
                    v-model.trim="item.title"
                    disabled
                  ></el-input>
                </p>
                <div
                  style="display: flex;"
                  @click="() => item.type === -3 && itemHover(item.type, index)"
                >
                  <span style="line-height:32px;">备注：</span>
                  <el-input
                    v-if="changeItemFlag === item.type + '_' + index + '_'"
                    :id="item.type + '_' + index + '_'"
                    type="textarea"
                    autosize
                    placeholder="如无备注信息，可不填（最多50字）"
                    style="width:320px;margin-bottom:15px"
                    v-model.trim="item.remark"
                    @focus="event => event.currentTarget.select()"
                    :maxlength="50"
                  ></el-input>
                  <el-input
                    v-else
                    :id="item.type + '_' + index + '_'"
                    :disabled="true"
                    type="textarea"
                    autosize
                    placeholder="如无备注信息，可不填（最多50字）"
                    style="width:320px"
                    v-model.trim="item.remark"
                    :maxlength="50"
                  ></el-input>
                </div>
                <!-- 目标题 -->
                <div
                  v-if="item.type == -1"
                  class="item-content-textone enclosure custom-input"
                >
                  <el-input
                    disabled
                    placeholder="请选择"
                    prefix-icon="el-icon-s-custom"
                    style="width:100%;margin-top:15px;"
                  ></el-input>
                  <el-input
                    v-if="common.departmentName"
                    disabled
                    placeholder="科室"
                    prefix-icon="el-icon-s-custom"
                    style="width:100%;margin-top:10px"
                    :value="common.departmentName"
                  ></el-input>
                </div>
                <!-- 时间段题 -->
                <div
                  v-else-if="item.type == -2"
                  class="item-content-textone enclosure custom-input"
                >
                  <el-input
                    disabled
                    placeholder="请选择时间"
                    prefix-icon="el-icon-time"
                    style="width:100%;color:red;margin-top:15px"
                  ></el-input>
                  <!-- 时刻题是否开启实时打卡 0未设置，1已设置-->
                  <div v-if="item.secondType == 2">
                    <el-switch
                      style="margin-top: 10px;"
                      v-model="item.realTimeCheckIn"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="实时打卡"
                    ></el-switch>
                  </div>
                </div>
                <!-- 拜访定位题 -->
                <div
                  v-else-if="item.type == -3"
                  class="item-content-textone enclosure"
                >
                  <div class="box">
                    <img src="http://cdn.yxvzb.com/WEB/SaaS/images/nail.png" />
                    <span>点击获取地理位置</span>
                  </div>
                  <!-- 定位图水印 -->
                  <el-switch
                    v-if="item.type == -3"
                    style="margin-top:15px"
                    v-model="item.isMakeScenePicWatermark"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="时间水印"
                  />
                </div>
              </el-card>
            </div>
            <!-- banner -->
            <vueDraggable
              ghostClass="ghost"
              handle=".mover"
              v-model="questionList"
              chosenClass="chosen"
              forceFallback="true"
              fallbackClass="draggingStyle"
              animation="1000"
              @end="onOver"
            >
              <transition-group>
                <el-card
                  :id="item.id"
                  shadow="hover"
                  class="item"
                  v-for="(item, index) in questionList.slice(0, scrollIndex)"
                  :key="item.id"
                >
                  <!-- 上部 -->
                  <div class="item-title">
                    <!-- 删除 移动 等操作 -->
                    <div class="item-mr">
                      <span style="margin-right: 10px;color:#999999">
                        [{{ item | questionTypeLabelFil }}]
                      </span>
                      <el-switch
                        v-if="needMustFill(item.type)"
                        style="margin-right:10px;"
                        v-model="item.isMustFill"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        inactive-color="#D9D9D9"
                        :active-text="item.isMustFill == 1 ? '必答' : '非必答'"
                      ></el-switch>
                      <el-tooltip
                        effect="light"
                        content="长按拖动题目"
                        placement="top-start"
                      >
                        <img
                          class="move-img mover"
                          src="@/assets/yidong.png"
                          alt
                        />
                      </el-tooltip>
                      <!-- <div style="font-size:14px;">
                      顺序
                      <el-input
                        class="question-edit-sort-input"
                        placeholder="顺序"
                        style="width:60px;padding:0;"
                        size="small"
                        :value="item.weight"
                        @blur="sortFlag = true"
                        @focus="sortFlag = false"
                        @input="val=>dealSortValue(val,item,item.weight)"
                      ></el-input>
                      </div>-->
                      <el-tooltip
                        effect="light"
                        content="点击删除题目"
                        placement="top-start"
                      >
                        <img
                          class="hand"
                          style="margin-left:15px"
                          src="@/assets/shanchu.png"
                          alt
                          @click="itemRemove(index)"
                        />
                      </el-tooltip>
                    </div>
                    <!-- 标题 -->
                    <div class="item-title__p" style="display:flex">
                      <span
                        :style="
                          item.isMustFill === 1
                            ? {
                                color: 'red',
                                'line-height': '40px',
                                'margin-right': '5px'
                              }
                            : {
                                color: 'rgba(255,255,255,0)',
                                'margin-right': '5px'
                              }
                        "
                      >
                        *
                      </span>
                      <el-input
                        class="question-edit-sort-input textarea-title"
                        placeholder="顺序"
                        style="width:80px;margin-right:5px"
                        size="small"
                        @blur="dealSortValue('', item, item.weight)"
                        @focus="
                          event => {
                            sortFlag = false;
                            event.currentTarget.select();
                          }
                        "
                        :value="
                          (item.newWeight || item.weight) +
                            dealQuestionList.length
                        "
                        @input="weightChange(item, $event)"
                      ></el-input>
                      <el-input
                        v-if="
                          changeItemFlag === item.type + '_' + index + '_title'
                        "
                        :id="item.type + '_' + index + '_title'"
                        class="textarea-title"
                        type="textarea"
                        autosize
                        v-model.trim="item.title"
                        :maxlength="200"
                        @focus="event => event.currentTarget.select()"
                        placeholder="标题最多可输入200个字"
                        @click.native="itemHover(item.type, index, 'title')"
                        @blur="itemOut"
                      />
                      <el-input
                        v-else
                        class="textarea-title"
                        type="textarea"
                        autosize
                        v-model.trim="item.title"
                        :maxlength="200"
                        disabled
                        @focus="event => event.currentTarget.select()"
                        placeholder="标题最多可输入200个字"
                        @click.native="itemHover(item.type, index, 'title')"
                        @blur="itemOut"
                      />
                    </div>
                  </div>
                  <div
                    style="margin-left:50px;padding:10px"
                    class="remark-input"
                    @click="itemHover(item.type, index)"
                    @blur="itemOut"
                  >
                    <span style="line-height:32px;">备注：</span>
                    <el-input
                      v-if="changeItemFlag === item.type + '_' + index + '_'"
                      :id="item.type + '_' + index + '_'"
                      type="textarea"
                      autosize
                      placeholder="如无备注信息，可不填（最多50字）"
                      style="width:320px"
                      v-model.trim="item.remark"
                      @focus="event => event.currentTarget.select()"
                      :maxlength="50"
                    ></el-input>
                    <el-input
                      v-else
                      :id="item.type + '_' + index + '_'"
                      :disabled="true"
                      type="textarea"
                      autosize
                      placeholder="如无备注信息，可不填（最多50字）"
                      style="width:320px"
                      v-model.trim="item.remark"
                      :maxlength="50"
                    ></el-input>
                  </div>
                  <div class="item-content">
                    <!-- 选择项 -->
                    <div
                      class="item-content-inputs"
                      v-if="item.type < 4 && item.type > 0"
                    >
                      <ul class="item-content-inputs-ul">
                        <li
                          v-for="(item2, index2) in item.list"
                          :key="index2"
                          @click="itemHover(item.type, index, index2, $event)"
                          @blur="itemOut"
                        >
                          <!-- 目标可编辑 -->
                          <div
                            v-if="
                              changeItemFlag ===
                                item.type + '_' + index + '_' + index2
                            "
                          >
                            <el-input
                              :id="item.type + '_' + index + '_' + index2"
                              type="textarea"
                              autosize
                              class="item2-input"
                              v-model.trim="item.list[index2]"
                              :maxlength="200"
                              @focus="event => event.currentTarget.select()"
                            />
                            <img
                              class="item2-remove hand"
                              src="@/assets/shanchu_yidianji.png"
                              alt
                              @click="item2Remove(index, index2)"
                              v-if="index2 != 0"
                            />
                          </div>
                          <!-- 不可编辑 -->
                          <el-input
                            type="textarea"
                            autosize
                            style="border-color:transparent"
                            class="item2-input"
                            v-else
                            :value="item2"
                            disabled
                          />
                        </li>
                      </ul>
                      <ul
                        class="item-content-inputs-add hand"
                        v-if="item.list.length < 50"
                      >
                        <li @click="item2Add(index)">
                          <img src="@/assets/xinzengxuanxiang.png" alt />
                          <span>新增选项</span>
                        </li>
                      </ul>
                    </div>
                    <!-- 单填空 -->
                    <div
                      class="item-content-textone"
                      v-else-if="item.type == 4"
                    >
                      <el-input
                        size="small"
                        placeholder="请填写本项内容"
                        disabled
                      ></el-input>
                    </div>
                    <!-- 数字填空题 -->
                    <div
                      class="item-content-textone item-content-19"
                      v-else-if="item.type == 19"
                    >
                      <el-input
                        size="small"
                        placeholder="请填写本项内容"
                        disabled
                      ></el-input>
                      <div>
                        <span>填写限制：</span>
                        <el-input
                          size="small"
                          v-model.trim="item.rule.minNum"
                          :placeholder="`${minFor19}`"
                          @input="
                            e => {
                              validate19Input(e, item, 'minNum');
                            }
                          "
                          @change="
                            e => {
                              validate19MinChange(e, item);
                            }
                          "
                        ></el-input>
                        <span>—</span>
                        <el-input
                          size="small"
                          v-model.trim="item.rule.maxNum"
                          :placeholder="`${maxFor19}`"
                          @input="
                            e => {
                              validate19Input(e, item, 'maxNum');
                            }
                          "
                          @change="
                            e => {
                              validate19MaxChange(e, item);
                            }
                          "
                        ></el-input>
                      </div>
                      <el-checkbox
                        v-model="item.rule.numberType"
                        :true-label="1"
                        :false-label="0"
                        @change="
                          e => {
                            changeBoxFor19(e, item);
                          }
                        "
                      >
                        显示小数，勾选后允许填写小数点后两位
                      </el-checkbox>
                    </div>
                    <!-- 多填空 -->
                    <div
                      class="item-content-inputs item-content-textmore"
                      v-else-if="item.type == 5"
                    >
                      <ul class="item-content-inputs-ul">
                        <li
                          v-for="(item2, index2) in item.list"
                          :key="index2"
                          @click="itemHover(item.type, index, index2)"
                          @blur="itemOut"
                        >
                          <!-- 目标可编辑 -->
                          <div
                            v-if="
                              changeItemFlag ===
                                item.type + '_' + index + '_' + index2
                            "
                          >
                            <el-input
                              :id="item.type + '_' + index + '_' + index2"
                              type="textarea"
                              autosize
                              class="item2-input"
                              v-model.trim="item.list[index2]"
                              :maxlength="200"
                              @focus="event => event.currentTarget.select()"
                            />
                            <img
                              class="item2-remove hand"
                              src="@/assets/shanchu_yidianji.png"
                              alt
                              @click="item2Remove(index, index2)"
                              v-if="index2 != 0"
                            />
                          </div>
                          <!-- 不可编辑 -->
                          <el-input
                            type="textarea"
                            autosize
                            style="border-color:transparent"
                            class="item2-input"
                            v-else
                            :value="item2"
                            disabled
                          />
                          <el-input
                            size="small"
                            style="width:80%;padding:10px 0 0 0"
                            placeholder="请填写本项内容"
                            disabled
                          />
                        </li>
                      </ul>
                      <ul
                        class="item-content-inputs-add hand"
                        v-if="item.list.length < 50"
                      >
                        <li @click="item2Add(index, '问题')">
                          <img src="@/assets/xinzengxuanxiang.png" alt />
                          <span>新增选项</span>
                        </li>
                      </ul>
                    </div>
                    <!-- 打分 -->
                    <div
                      class="item-content-textone"
                      v-else-if="item.type == 6"
                    >
                      <el-rate
                        style="font-size:30px"
                        disabled
                        text-color="#ff9900"
                      ></el-rate>
                    </div>
                    <!-- 上传附件 -->
                    <div
                      class="item-content-textone enclosure"
                      v-else-if="fileTypeList.includes(item.type)"
                    >
                      <ul style="justify-content:flex-start;">
                        <li
                          v-for="(item2, index) in item.fileListLength"
                          :key="index"
                          style="margin-right:5px;"
                        ></li>
                      </ul>
                      <p>文件仅支持{{ item.type | transType }}，不超过20M</p>
                      <div
                        style="display:flex;align-items:center;margin-top:5px;"
                        v-if="item.type === 13"
                      >
                        <span>最少图片数量：</span>
                        <el-input-number
                          size="mini"
                          v-model="item.fileListLength"
                          :max="10"
                          :min="1"
                          placeholder="最多10张"
                          @blur="avoidEmpty(item.fileListLength, index)"
                        ></el-input-number>
                        <el-switch
                          style="margin-left:10px;"
                          v-model="item.isDateWatermark"
                          :active-value="1"
                          :inactive-value="0"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          active-text="时间水印"
                        ></el-switch>
                      </div>
                    </div>
                    <!-- 时间题 -->
                    <div
                      v-else-if="item.type == 14"
                      class="item-content-textone enclosure"
                    >
                      <el-date-picker
                        disabled
                        type="datetime"
                        placeholder="选择时间（年/月/日/时/分）"
                        style="width:400px;margin-top:30px;"
                      ></el-date-picker>
                    </div>
                    <!-- 月度题 -->
                    <div
                      v-else-if="item.type == 15"
                      class="item-content-textone enclosure"
                    >
                      <el-date-picker
                        disabled
                        type="month"
                        placeholder="选择时间（年/月）"
                        style="width:400px;margin-top:30px;"
                      ></el-date-picker>
                    </div>
                    <!-- 定位题 -->
                    <div
                      v-else-if="item.type == 16"
                      class="item-content-textone enclosure"
                    >
                      <div class="box">
                        <img
                          src="http://cdn.yxvzb.com/WEB/SaaS/images/nail.png"
                        />
                        <span>点击获取地理位置</span>
                      </div>
                    </div>
                    <!-- 描述题 -->
                    <div
                      class="item-content-textone"
                      v-else-if="item.type == 18"
                    >
                      <el-input
                        type="textarea"
                        autosize
                        v-model="item.list[0]"
                        :maxlength="300"
                        placeholder="请填写描述内容"
                      ></el-input>
                    </div>
                    <div
                      v-else-if="item.type == 20"
                      class="item-content-textone enclosure"
                    ></div>
                  </div>
                </el-card>
              </transition-group>
            </vueDraggable>
          </div>
        </div>
      </el-scrollbar>
      <div class="question-right-bts">
        <div class="l-btn-group">
          <el-button class="btn l-normal" @click="lookQuestion">预览</el-button>
          <!-- <el-button class="btn l-normal" @click="lookQuestion" v-if="data.id">预览</el-button>
          <el-button class="btn l-normal" v-else @click="$router.go(-1)">关闭</el-button>-->
          <el-button
            :loading="submiting"
            :disabled="submiting"
            type="primary"
            class="btn"
            @click="save"
          >
            保存
          </el-button>
          <el-button type="info" class="btn" @click="$router.go(-1)">
            返回
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui';
import vueDraggable from 'vuedraggable';
import { makeScene } from '@/api/ajax';
import Config from '@/config';
import { setStorage } from '@/tools/storage';
import { makeSure } from '@/tools';
import {
  validate19Input,
  validate19MaxChange,
  validate19MinChange,
  maxFor19,
  minFor19,
  validateSaveDataFor19,
  changeBoxFor19
} from './services/19.js';
import importTemplate from './importTemplate.vue';
export default {
  data() {
    return {
      maxFor19,
      minFor19,
      weightA: '',
      sortFlag: true, // 是否排序
      submiting: false,
      ifrUrl: `${Config.webViewUrl}${Config.webPath}/configure?isPreview=2`,
      ifrHeight: '450px', // iframe 高度
      dialogVisible: false, // 是否显示预览
      draggable: true, // 是否可以拖拽，当为input时 false
      // 当目标滑到时可以编辑选项，此为可编辑的标识 item.type_item.id_item.list.index
      changeItemFlag: '',
      // 点击编辑标题 直接为index
      changeTitleFlagIndex: -1,
      questionListOrigin: [],
      commonOrigin: {},
      fileTypeList: [8, 9, 10, 11, 12, 13],
      visitTypeList: [-1, -2, -3],
      // 题目类型   1 单选  2 多选  3 单项投票  4 单项填空 5 多项填空 6 打分题  7 地址 8 上传附件 9 pdf 10 word 11 excel 12 ppt 13 jpg/png
      typeList: [
        {
          title: '选择题：',
          list: [
            {
              title: '单选题',
              type: 1,
              icon: require('@/assets/danxuanti.png')
            },
            {
              title: '多选题',
              type: 2,
              icon: require('@/assets/duoxuanti.png')
            },
            {
              title: '单选投票题',
              type: 3,
              icon: require('@/assets/danxuantoupiaoti.png')
            }
          ]
        },
        {
          title: '填空题：',
          list: [
            {
              title: '单项填空题',
              type: 4,
              icon: require('@/assets/danxuantiankongti.png')
            },
            {
              title: '多项填空题',
              type: 5,
              icon: require('@/assets/duoxuantiankongti.png')
            },
            {
              title: '数字填空题',
              type: 19,
              icon: require('@/assets/duoxuantiankongti.png')
            },
            {
              title: '姓名填空题',
              type: 22,
              icon: require('@/assets/danxuanti.png')
            }
          ]
        },
        {
          title: '打分题：',
          list: [
            { title: '打分题', type: 6, icon: require('@/assets/dafenti.png') }
          ]
        },
        {
          title: '个人信息：',
          list: [
            {
              title: '姓名',
              type: 4,
              secondType: 4,
              icon: require('@/assets/danxuanti.png')
            },
            {
              title: '手机',
              type: 4,
              secondType: 2,
              icon: require('@/assets/danxuanti.png')
            },
            {
              title: '邮箱',
              type: 4,
              secondType: 3,
              icon: require('@/assets/youxiang.png')
            },
            {
              title: '签名题',
              type: 20,
              icon: require('@/assets/youxiang.png')
            }
          ]
        },
        {
          title: '附件上传：',
          list: [
            { title: 'PDF上传', type: 9, icon: require('@/assets/fujian.png') },
            {
              title: 'WORD上传',
              type: 10,
              icon: require('@/assets/fujian.png')
            },
            {
              title: 'PPT上传',
              type: 12,
              icon: require('@/assets/fujian.png')
            },
            {
              title: 'EXCEL上传',
              type: 11,
              icon: require('@/assets/fujian.png')
            },
            {
              title: '图片上传',
              type: 13,
              icon: require('@/assets/fujian.png')
            }
          ]
        },
        {
          title: '信息提交：',
          list: [
            {
              title: '时间题',
              type: 14,
              icon: require('@/assets/dafenti.png')
            },
            {
              title: '月度题',
              type: 15,
              icon: require('@/assets/dafenti.png')
            }
          ]
        },
        {
          title: '描述：',
          list: [
            {
              title: '描述题',
              type: 18,
              icon: require('@/assets/danxuantiankongti.png')
            }
          ]
        }
      ],
      /**  questionList 渲染数据
       *    内部结构 ：
       * {
       *   type: item.type,
       *   list: ["选项1", "选项2", "选项3", "选项4"],
       *   title: `此题为${item.title}`,
       *   id: Date.now()
       * }
       */
      questionList: [],
      dealQuestionList: [],
      dragging: null, // drag 当前 数据

      common: {
        banner: '', // 封面图地址
        sceneTitle: '', // 标题
        explainSm: '', // 描述
        id: '' // 问卷ID
      },
      scrollTop: 0,
      scrollIndex: 60
    };
  },
  inject: {
    app: {
      default: {}
    }
  },
  components: {
    vueDraggable,
    importTemplate
  },
  filters: {
    transType(v) {
      let obj = {
        8: '文件',
        9: 'pdf',
        10: 'word',
        11: 'excel',
        12: 'ppt',
        13: 'jpg/png'
      };
      return obj[v];
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    questionListByComputed() {
      if (!this.sortFlag) {
        return this.questionList;
      }
      return (this.questionList || []).sort((a, b) => a.weight - b.weight);
    }
  },
  methods: {
    validate19Input,
    validate19MaxChange,
    validate19MinChange,
    changeBoxFor19,
    questionListUpdate(list) {
      if (!Array.isArray(list)) {
        return;
      }
      this.questionList.push(
        ...list.map(item => ({
          ...item,
          weight: +item.weight + this.questionList.length
        }))
      );
    },
    weightChange(item, event) {
      if (!item.beforeWeight) {
        item.beforeWeight = item.weight;
      }
      this.$set(item, 'weight', Number(event) - this.dealQuestionList.length);
      // item.weight = Number(event)
    },
    needMustFill(type) {
      return [17, 18].includes(type) ? 0 : 1;
    },
    lookQuestion() {
      makeSure(
        () => {},
        {},
        <div style="height:450px;overflow:auto;">
          <iframe
            style="pointer-events: none;"
            id="iframe"
            scrolling="no"
            src={this.ifrUrl}
            frameborder="0"
            onLoad={this.iframeLoad}
            width="100%"
            height={this.ifrHeight}
          ></iframe>
        </div>,
        '',
        {
          showCancelButton: false
        }
      );
    },
    beforeUpload(file) {
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('上传文件大小不得超过5M');
        return false;
      }
    },
    checkProjectId() {
      this.$message.error('项目信息已丢失，请重新选择项目');
      this.$router.go(-1);
    },
    avoidEmpty(val, index) {
      if (!val) {
        this.$message({
          message: '上传附件的数量最少为1',
          type: 'warning'
        });
        this.questionList[index].fileListLength = 1;
      }
    },
    handleUpload() {
      this.$refs.uploadOne.$refs.uploader.$refs['upload-inner'].handleClick();
    },
    waitPicDone(v) {
      this.common.banner = v;
    },
    // 设置修改title 下标
    setTitleFlag(index) {
      this.changeTitleFlagIndex = index;
    },
    // 标题input out事件重置标识
    titleBlur(item) {
      if (!item.title.length) {
        item.title = '默认标题';
      }
      this.changeTitleFlagIndex = -1;
    },
    // 选项移出时重置标识
    itemOut() {
      this.changeItemFlag = '';
    },
    // 选项移入写入标识
    itemHover(parentType, parentId, index) {
      this.changeItemFlag = `${parentType}_${parentId}_${
        index === undefined ? '' : index
      }`;
      this.$nextTick(() => {
        document
          .getElementById(
            parentType +
              '_' +
              parentId +
              '_' +
              (index === undefined ? '' : index)
          )
          .focus();
      });
    },
    defaultOptionJson(type) {
      let defaultMap = {
        5: ['问题1'],
        18: ['']
      };
      return defaultMap[type] || ['选项1'];
    },
    // 添加选题
    pushQuestion(item) {
      const lastSort = parseInt(
        (this.questionListByComputed.slice(-1)[0] || {}).weight || 0
      );
      let rule = {};
      if (item.type === 19) {
        rule = {
          minNum: '',
          maxNum: '',
          numberType: 0 // 1显示小数 0不显示
        };
      }
      const obj = {
        placeholder: item.placeholder,
        isMustFill: this.needMustFill(item.type),
        type: item.type,
        list: this.defaultOptionJson(item.type),
        title: `此题为${item.title}（点击编辑题干）`,
        id: Date.now() + this.questionList.length * 10, // 新建没有ID，使用时间戳
        isNew: 1,
        fileListLength: 1,
        secondType: item.secondType || 1,
        weight: isNaN(lastSort) ? 0 : lastSort + 1,
        rule
      };
      if (this.visitTypeList.includes(item.type)) {
        const index = this.dealQuestionList.findIndex(i => i.type == item.type);
        if (index > -1) {
          if (item.type == -1) {
            this.$set(this.dealQuestionList, index, obj);
          }
        } else {
          this.dealQuestionList.push(obj);
        }
        this.dealQuestionList.sort((a, b) => {
          if (a.type < b.type) {
            return -1;
          }
        });
      } else {
        this.questionList.push(obj);
      }
    },
    // 删除选项
    item2Remove(parentIndex, childIndex) {
      this.questionList[parentIndex].list.splice(childIndex, 1);
    },
    // 添加选项
    item2Add(parentIndex, name = '选项') {
      this.questionList[parentIndex].list.push(
        `${name}${this.questionList[parentIndex].list.length + 1}`
      );
    },
    // 删除整项
    itemRemove(index, arrName = 'questionList') {
      this[arrName].splice(index, 1);
      this.questionList.forEach((question, index) => {
        question.weight = index + 1;
      });
    },
    dealSortValue(val, item) {
      // item.beforeWeight = item.weight
      // item.weight = item.newWeight
      if (!item.beforeWeight) {
        return;
      }
      if (item.weight > this.questionList.length) {
        item.weight = this.questionList.length;
      }
      this.questionList.splice(item.beforeWeight - 1, 1);
      this.questionList.splice(item.weight - 1, 0, item);
      this.questionList = (this.questionList || []).sort(
        (a, b) => a.weight - b.weight
      );
      this.questionList.forEach((question, index) => {
        question.beforeWeight = undefined;
        question.weight = index + 1;
      });
    },
    save() {
      this.saveConfirm();
    },
    dealSceneQuestion(sceneQuestionArr) {
      const targetObj = {
        isSetLocation: 0,
        isSetTarget: 0,
        isSetTime: 0
      };
      if (Array.isArray(sceneQuestionArr)) {
        sceneQuestionArr.forEach(item => {
          const {
            type,
            placeholder,
            title,
            remark,
            secondType,
            isMakeScenePicWatermark,
            realTimeCheckIn
          } = item;
          if (type == -1) {
            // 目标题
            targetObj.isSetTarget = 1;
            targetObj.targetPlaceholder = placeholder;
            targetObj.targetTitle = title;
            targetObj.targetRemark = remark;
            targetObj.targetType = secondType;
          }
          if (type == -2) {
            // 时间段题
            targetObj.isSetTime = 1;
            targetObj.timeTitle = title;
            targetObj.timeRemark = remark;
            targetObj.timeType = secondType;
            targetObj.realTimeCheckIn = realTimeCheckIn;
          }
          if (type == -3) {
            // 定位题
            targetObj.isSetLocation = 1;
            targetObj.locationTitle = title;
            targetObj.locationRemark = remark;
            targetObj.isMakeScenePicWatermark = isMakeScenePicWatermark;
          }
        });
      }
      return targetObj;
    },
    // 保存
    saveConfirm(isAutoSave = false) {
      if (this.submiting) return;
      const { sceneTitle } = this.common;
      if (!sceneTitle) {
        !isAutoSave && this.$message.error('请输入场景名称');
        return;
      }
      // if (!sceneRemark) {
      //   this.$message.error('请输入说明');
      //   return;
      // }
      if (this.questionList.length > 256) {
        Message({ message: '题目数量超过256个，请重新编辑', type: 'error' });
        return;
      }
      const targetObj = this.dealSceneQuestion(this.dealQuestionList);
      let data = {
        ...this.common,
        ...this.formInline,
        ...targetObj,
        makeScenceId: this.common.id,
        topics: []
      };

      this.questionList.forEach((item, index) => {
        let { list, id, ...option } = item;
        data.topics[index] = item;
        // 新建时没有ID，使用时间戳的不提交ID字段
        if (data.topics[index].id < 10000000) {
          data.topics[index].id = id;
        }
        // 数字题保存时设置默认最小、大值
        if (option.type == 19) {
          const resp19 = validateSaveDataFor19(data.topics[index]);
          if (!resp19.status) {
            this.$message({
              showClose: true,
              message: resp19.message,
              type: 'error'
            });
            throw new Error(resp19.message);
          }
        }
        if (option.type == 5) {
          data.topics[index].manyTitleJson = list;
        } else if (this.fileTypeList.includes(option.type)) {
          //上传文件类型
          data.topics[index].optionJson = Array.isArray(item.fileListLength)
            ? item.fileListLength
            : [item.fileListLength];
        } else {
          data.topics[index].optionJson = list;
        }
        data.topics[index].weight = data.topics[index].weight || 0;
        data.topics[index] = JSON.stringify(data.topics[index]);
      });
      this.dialogVisible = false;
      const { targetTitle = '', timeTitle = '', locationTitle = '' } = data;
      if (isAutoSave) {
        // 自动保存
        makeScene.updateMakeSceneInfo(data).then(() => {
          //Origin源数据用于保存时对比是否编辑
          this.questionListOrigin = JSON.parse(
            JSON.stringify(this.questionList)
          );
          this.commonOrigin = JSON.parse(JSON.stringify(this.common));
          this.$message.success('自动保存成功');
          this.$sentry.captureMessage(
            `可配置自动保存-${this.formInline.projectId}`,
            {
              level: 'info',
              contexts: {
                data: {
                  json: JSON.stringify(data)
                }
              }
            }
          );
        });
      } else {
        this.submiting = true;
        this.$checkCopyProjectBIConfigs({
          projectId: this.formInline.projectId,
          tips: msg =>
            `您若保存项目场景信息，BI中${msg}数据将会被清空，是否继续保存？`,
          callback: isConfirm => {
            if (!isConfirm) {
              //问卷重复弹窗点击取消
              this.submiting = false;
              return;
            }
            this.$checkQuestionnaireIsAlike({
              projectId: this.formInline.projectId,
              projectType: this.formInline.projectType,
              webStr: `${timeTitle}${locationTitle}${targetTitle}${this.$dealQuestionnaire(
                data.topics
              )}`,
              callback: isConfirm => {
                if (!isConfirm) {
                  //问卷重复弹窗点击取消
                  this.submiting = false;
                  return;
                }
                makeScene
                  .updateMakeSceneInfo(data)
                  .then(() => {
                    this.submiting = false;
                    //Origin源数据用于保存时对比是否编辑
                    this.questionListOrigin = JSON.parse(
                      JSON.stringify(this.questionList)
                    );
                    this.commonOrigin = JSON.parse(JSON.stringify(this.common));
                    this.$message.success('编辑成功');
                    this.$sentry.captureMessage(
                      `可配置手动保存-${this.formInline.projectId}`,
                      {
                        level: 'info',
                        contexts: {
                          data: {
                            json: JSON.stringify(data)
                          }
                        }
                      }
                    );
                    // this.data.callback &&
                    //   this.data.callback({
                    //     idAdd: this.common.id,
                    //     templateId: res.data.data.id,
                    //     templateName: data.templateName,
                    //     updateDt: new Date().getTime()
                    //   });
                    this.$router.go(-1);
                  })
                  .catch(() => {
                    this.submiting = false;
                  });
              }
            });
          }
        });
      }
    },

    /////////////////////////////////////////////////拖拽/////////////////////////////////////////////////////////
    // 开始拖拽目标
    handleDragStart(e, item) {
      let { className } = e.target;
      if (className.includes('move-img')) {
        this.dragging = item;
        return false;
      }
      this.dragging = null;
    },
    // 放置目标
    handleDragEnd() {
      this.dragging = null;
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      if (!this.dragging) {
        return false;
      }
      e.dataTransfer.dropEffect = 'move'; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
      // var node=document.createElement("div");
      // node.innerText="test"
      // e.target.appendChild(node)
    },
    // 此处直接使用drop 未使用 dragenter
    handleDrop(e, item) {
      if (!this.dragging) {
        return false;
      }
      e.dataTransfer.effectAllowed = 'move'; //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return;
      }
      let weight = item.weight;
      this.dragging.weight = weight - 0.5;
      this.questionList = (this.questionList || []).sort(
        (a, b) => a.weight - b.weight
      );
      this.dragging.weight = weight;
      this.questionList.forEach((question, index) => {
        if (question.weight >= weight) {
          question.weight = index + 1;
        }
      });
    },
    onOver() {
      this.questionList.forEach((question, index) => {
        question.weight = index + 1;
      });
    },
    /////////////////////////////////////////////iframe/////////////////////////////////////////////////////////////////////

    iframeLoad() {
      this.$nextTick(() => {
        let ifrDom = document.getElementById('iframe');
        // setTimeout(() => {

        // }, 1500);
        let data = {
          tSaasQuestionnaire: this.common,
          tSaasMakeSceneProjectTopicList: [],
          tSaasMakeSceneBaseProject: this.dealSceneQuestion(
            this.dealQuestionList
          )
        };
        this.questionList.forEach((item, index) => {
          let { list, id, ...option } = item;
          data.tSaasMakeSceneProjectTopicList[index] = item;
          // 新建时没有ID，使用时间戳的不提交ID字段
          if (data.tSaasMakeSceneProjectTopicList[index].id < 10000000) {
            data.tSaasMakeSceneProjectTopicList[index].id = id;
          }
          if (option.type == 5) {
            data.tSaasMakeSceneProjectTopicList[index].manyTitleJson = list;
          } else {
            data.tSaasMakeSceneProjectTopicList[index].optionJson = list;
          }
        });
        ifrDom.contentWindow.emitPreview(data);
        ifrDom.setAttribute('height', 'auto');
        setTimeout(() => {
          ifrDom.setAttribute(
            'height',
            ifrDom.contentWindow.document.documentElement.scrollHeight + 'px'
          );
        }, 500);
      });
    },
    // 点击预览 ， 向iframe 传入数据
    preveiw() {
      this.dialogVisible = true;
    },
    initData(projectId, projectType) {
      if (projectId && projectType) {
        makeScene
          .makeSceneInfoByProject({ projectId, projectType })
          .then(res => {
            const {
              topics,
              sceneTitle,
              sceneRemark,
              id,
              isSetLocation,
              isSetTarget,
              isSetTime,
              isMakeScenePicWatermark, // 定位图水印
              departmentId,
              departmentName,
              firstDepartmentId,
              firstDepartmentName
            } = res.data.data;
            const infoObj = res.data.data || {};
            this.common = {
              sceneTitle,
              sceneRemark,
              templateid: id,
              id,
              departmentId,
              departmentName,
              firstDepartmentId,
              firstDepartmentName
            };
            const targetTypeStatusArr = [
              {
                type: -1,
                status: isSetTarget,
                title: infoObj.targetTitle,
                remark: infoObj.targetRemark,
                secondType: infoObj.targetType
              },
              {
                type: -2,
                status: isSetTime,
                title: infoObj.timeTitle,
                remark: infoObj.timeRemark,
                secondType: infoObj.timeType,
                realTimeCheckIn: infoObj.realTimeCheckIn
              },
              {
                type: -3,
                status: isSetLocation,
                title: infoObj.locationTitle,
                remark: infoObj.locationRemark,
                isMakeScenePicWatermark
              }
            ];
            this.dealQuestionList = targetTypeStatusArr.reduce((pre, cur) => {
              const {
                type,
                status,
                realTimeCheckIn,
                title,
                remark,
                secondType,
                isMakeScenePicWatermark
              } = cur;
              status == 1 &&
                pre.push({
                  realTimeCheckIn,
                  type,
                  title,
                  remark,
                  secondType,
                  isMakeScenePicWatermark
                });
              return pre;
            }, []);
            //已编辑的调查问卷项目
            this.questionList = topics
              .map((item, index) => {
                let { optionJson, manyTitleJson, ...options } = item;
                let questionItem = options;
                let childList = optionJson || manyTitleJson;
                if (questionItem.type === 19) {
                  if (!questionItem.rule) {
                    questionItem.rule = {
                      minNum: '',
                      maxNum: '',
                      numberType: 0 // 1显示小数 0不显示
                    };
                  } else {
                    try {
                      questionItem.rule = JSON.parse(questionItem.rule);
                    } catch (e) {
                      console.error(e);
                    }
                  }
                }
                try {
                  childList = JSON.parse(childList);
                  optionJson = JSON.parse(optionJson);
                } catch (err) {
                  console.error(err);
                }
                questionItem.list = childList;
                questionItem.imageLeastNumber =
                  questionItem.imageLeastNumber || 0;
                questionItem.imageMostNumber =
                  questionItem.imageMostNumber || 0;
                questionItem.isDateWatermark =
                  questionItem.isDateWatermark || 0;
                questionItem.remark = questionItem.remark || '';
                questionItem.weight = parseInt(
                  questionItem.weight || index + 1
                );

                this.fileTypeList.includes(item.type)
                  ? optionJson.length === 0
                    ? (questionItem.fileListLength = 1)
                    : (questionItem.fileListLength = optionJson)
                  : '';
                return questionItem;
              })
              .sort((a, b) => a.weight - b.weight);

            //Origin源数据用于保存时对比是否编辑
            this.questionListOrigin = JSON.parse(
              JSON.stringify(this.questionList)
            );
            this.commonOrigin = JSON.parse(JSON.stringify(this.common));
            // 自动保存60s
            // this.timer = setInterval(() => {
            //   this.saveConfirm(true);
            // }, 60 * 1000);
          });
      }
    },
    scrollFn(e) {
      const { scrollTop } = e.target;
      if (scrollTop > this.scrollTop) {
        this.scrollTop = scrollTop;
        this.scrollIndex += 5;
      }
    },
    //可配置/调研场景-场景 20 5 隐藏姓名题
    showUserName(projectType) {
      if ([20, 5].includes(Number(projectType))) {
        this.typeList[3].list = this.typeList[3].list.filter(item => {
          return item['title'] !== '姓名';
        });
      }
    }
  },
  watch: {
    changeItemFlag(v) {
      this.draggable = !v;
    },
    changeTitleFlagIndex(v) {
      this.draggable = v == -1;
    }
  },
  created() {
    const { projectId, projectType } = this.$route.query;
    this.showUserName(projectType);
    this.formInline = {
      projectId,
      projectType
    };
    this.initData(projectId, projectType);
    setStorage('questionEdit', this.formInline);
    try {
      document
        .querySelector('.app-content')
        .addEventListener('scroll', this.scrollFn);
    } catch (error) {
      this.scrollIndex = 500;
    }
  },
  beforeRouteLeave(to, from, next) {
    //离开路由时对比是否编辑
    //编辑过后弹窗提示保存
    const questionListEqual =
      JSON.stringify(this.questionListOrigin) ==
      JSON.stringify(this.questionList);
    const commonEqual =
      JSON.stringify(this.common) == JSON.stringify(this.commonOrigin);
    if (questionListEqual && commonEqual) {
      next();
    } else {
      // 浏览器前进后退
      if (this.$route.fullPath !== window.location.href.split('/#')[1]) {
        window.confirm('当前页面未保存是否继续跳转?')
          ? next()
          : window.history.forward();
        return;
      }
      this.$confirm('当前页面未保存是否继续跳转', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        next();
      });
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (document.querySelector('.app-content')) {
      document
        .querySelector('.app-content')
        .removeEventListener('scroll', this.scrollFn);
    }
  }
};
</script>
<style lang="scss">
.question {
  .el-textarea.is-disabled,
  .is-disabled,
  .el-textarea__inner {
    cursor: default !important;
  }
  .el-rate__icon {
    font-size: 30px;
  }
  .upload-img.upload-one {
    width: 100%;
    height: 196px;
    border: none;
    .el-upload {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
// $--left-width: 30%;
// $--right-width: 65%;
$--left-width: 30%;
$--right-width: 650px;
$paddingBottom: 8px;

.question-right-c {
  ::v-deep {
    textarea[disabled] {
      pointer-events: none;
    }
  }
}
.remark-input:hover,
.textarea-title:hover {
  border: 1px dashed #dddddd;
}
.remark-input {
  border: 1px dashed rgba(0, 0, 0, 0);
}
.textarea-title {
  padding: 10px;
  border: 1px dashed rgba(0, 0, 0, 0);
}
.ghost {
  // width: 100px;
  height: 20px;
  border: 2px dashed #1890ff !important;
  // background-color: red !important;
}
.scroll {
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
    background: rgba(0, 0, 0, 0);
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #a5a5a5;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: rgba(0, 0, 0, 0);
    width: 0;
  }
}

.preview {
  width: 375px;
  height: 550px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: auto;
}
.question {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  // height: calc(100vh - 160px);
  background-color: #fff;
  position: relative;
  padding: 30px;
  & > .back-btn {
    position: absolute;
    left: 15px;
    top: 0;
  }
  .l-c-title {
    font-size: 17px;
    font-weight: bold;
    color: rgba(50, 50, 53, 1);
    line-height: 1;
    text-align: center;
    margin-bottom: 15px;
  }
  // 左侧
  &-left {
    // width: $--left-width;
    // min-width: 180px;
    height: auto;
    padding: 20px;
    background: #f5f7fa;
    padding: 16px;
    height: 100%;
    padding-top: 24px;
    @extend .scroll;
    overflow: auto;
    & > ul {
      background-color: #fff;
      padding: 12px;
      margin-bottom: $paddingBottom;
      &:last-child {
        margin-bottom: 0;
      }
    }
    // 标题
    &-title {
      font-size: 14px;
      line-height: 14px;
      text-align: left;
      &::before {
        width: 6px;
        height: 14px;
      }
    }
    // 内容
    &-item2 {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        min-height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #999999;
        margin-top: 12px;
        padding-left: 5px;
        padding-right: 3px;
        transition: all 0.2s;
        cursor: pointer;
        &:nth-child(odd) {
          margin-right: 5px;
        }
        img {
          width: 14px;
          height: 14px;
          margin-right: 6px;
        }
        &:hover {
          border-color: #409eff;
          background-color: #409eff;
          color: #fff;
          img {
            filter: grayscale(100%) brightness(200%);
          }
        }
        &.blank {
          margin: 0;
          border: none;
          height: 1px;
          min-height: 0;
        }
        span {
          font-size: 12px;
        }
        @media screen and (max-width: 1180px) {
          width: 100%;
          margin-right: 0 !important;
        }

        @media screen and (max-width: 1700px) and (min-width: 1181px) {
          width: 45%;
        }

        @media screen and (max-width: 1920px) and (min-width: 1701px) {
          width: 28%;
        }
        @media screen and (min-width: 1921px) {
          width: 28%;
        }
      }
    }
  }
  // 右侧
  &-right {
    width: $--right-width;
    height: 100%;
    padding: 16px;
    background: #f5f7fa;
    position: relative;
    padding-top: 0;
    padding-right: 0;
    margin-left: 30px;
    ::v-deep {
      .custom-input {
        .el-input__icon {
          color: #1989fa;
        }
        .el-input--prefix .el-input__inner {
          color: #1989fa;
        }
      }
      .upload-one .avatar-uploader-icon {
        width: initial;
        height: initial;
        line-height: 1;
      }
    }
    &-block {
      height: 100%;
      background-color: #f5f7fa;
      overflow: auto;
      @extend .scroll;
      padding-bottom: 60px;
      padding-top: 24px;
      padding-right: 16px;
    }
    // 按钮
    &-bts {
      display: flex;
      justify-content: center;
      padding-top: 10px;
      height: 60px;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 2;
      .el-button {
        width: 120px;
        height: 40px;
        padding: 0;
      }
    }
    .padding {
      padding: 16px;
    }
    &-top {
      background-color: #fff;
      margin-bottom: $paddingBottom;
      &-upload {
        width: 33.9vw;
        height: 22.4vw;
        background: rgba(245, 245, 245, 1);
        margin: auto;
        margin-bottom: 50px;
        text-align: center;
        display: block;
        position: relative;
        .logo-icon {
          width: 20.92%;
          height: auto;
          margin-top: 15%;
          margin-bottom: 6%;
        }
        .upload-icon {
          width: 20px;
          height: 18px;
          position: absolute;
          right: 22px;
          top: 22px;
        }
        p {
          font-size: 14px;
          color: #333;
        }
      }
    }
    // 内容
    &-c {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    // 元素
    .item {
      transition: all linear 0.3s;
      margin-bottom: 30px;
      background-color: #fff;
      margin-bottom: 12px;
      text-align: left;
      &-title {
        // display: flex;
        // justify-content: space-between;
        // margin-bottom: 8px;
      }
      &-mr {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        &-spacebetween {
          justify-content: space-between;
        }
      }
      &-title__p {
        display: flex;
        align-items: flex-start;
        margin: 15px 0;
        font-size: 16px;
        textarea {
          padding: 2px 0;
          width: 100%;
        }
      }

      &-content {
        padding-left: 50px;
        margin-top: 10px;
        // padding: 0 30px;
        // 子元素 输入框
        .item2-input {
          width: 80%;
        }
        .item2-input:disabled {
          background: #fff;
        }
        // 子元素 文本框
        .item2-text {
          height: 38px;
          padding: 0 7px;
          border: 1px solid rgba(221, 221, 221, 1);
        }
        // 子元素 更多文本
        &-textmore {
          .item2-text {
            margin-top: 10px;
          }
        }
        // 选择项
        &-inputs {
          &-ul {
            li:hover {
              border-color: #dddddd;
            }
            li {
              padding: 10px;
              border: 1px dashed transparent;
              position: relative;
              .item2-remove {
                width: 21px;
                height: 18px;
                position: absolute;
                top: 50%;
                right: 30px;
                transform: translateY(-50%);
              }
            }
          }
          // 子添加
          &-add {
            margin-top: 13px;
            font-size: 12px;
            color: #1989fa;
            display: flex;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
              margin-right: 12px;
            }
          }
        }
        &-19 {
          div {
            display: flex;
            align-items: center;
            margin: 15px;
            .el-input {
              width: 140px;
            }
          }
        }
      }
    }
  }
}
@mixin d {
  position: absolute;
  content: '';
  border-radius: 3px;
  background: #ccc;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.enclosure {
  ul {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    flex-wrap: wrap;
    justify-content: space-around;
    li {
      width: 99px;
      height: 99px;
      border-radius: 8px;
      background: #f1f1f1;
      position: relative;
      margin-bottom: 5px;
      background-image: url('http://cdn.yxvzb.com/WEB/SaaS/images/file2.png');
      background-size: 50% 50%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  p {
    color: #cccccc;
    margin-top: 10px;
  }
  .box {
    width: 100%;
    height: 100px;
    display: flex;
    line-height: 200px;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 2px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    img {
      width: 20px;
      height: 23px;
      vertical-align: center;
      object-fit: contain;
      margin-right: 10px;
    }
    span {
      color: #1890ff;
    }
  }
}
.chosen {
  border: solid 2px #3089dc;
}
.draggingStyle {
  height: unset !important;
  transform: translateY(-80%) scale(0.8);
  z-index: 1000000;
  // background-color: red !important;
}

.upload-template {
  padding-top: 55px !important;
  padding-bottom: 55px !important;
  .text {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }
  }
  .tips {
    font-size: 14px;
    color: #999999;
    line-height: 1.3;
    margin-top: 18px;
    text-align: center;
  }
}
</style>
